import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';

const routes: Routes = [
  {
    path: 'errors/property-not-found',
    loadChildren: () => import('./errors/property-not-found/property-not-found.module').then(m => m.PropertyNotFoundPageModule)
  },
  {
    path: 'errors/something-went-wrong',
    loadChildren: () => import('./errors/base-error/base-error.module').then( m => m.BaseErrorPageModule)
  },
  {
    path: '',
    loadChildren: () => import('./main/main.module').then( m => m.MainPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
